<template>
  <div class="trust-form-layout">
    <el-row type="flex" justify="space-between">
      <el-col class="title-bar" :span="8">
        <slot name="title"></slot>
      </el-col>
      <el-col class="action-bar" :span="16">
        <slot name="action-bar"></slot>
      </el-col>
    </el-row>
    <el-row>
      <el-col class="btn_tabs" :span="24">
        <slot name="btn_tabs"></slot>
      </el-col>
    </el-row>
    <el-row>
      <v-card class="main-content">
        <slot name="main-content"></slot>
      </v-card>
    </el-row>
    <el-row>
      <slot name="sumbit_box"></slot>
    </el-row>
  </div>
</template>

<script>
import vCard from '@/components/common/Card'
export default {
  components: {
    vCard,
  },
}
</script>

<style lang="less">
.trust-form-layout {
  .title-bar {
    margin-top: 10px;
    margin-bottom: 30px;
    p, span, h1, h2, h3, h4, h5, h6 {
      font-size: 26px;
      color: #86939e;
      margin: 0;
    }
  }
  .main-content {
    min-height: 300px;
  }
  .el-tabs__active-bar{
    background-color: rgba(0,0,0,0);
  }
  .complex-table .table-header{
    background-color: #e5e9f2;
    margin-bottom: 20px;
  }
  .complex-table .sub-row-table .sub-body [data-v-31368ffa]:last-child{
    border: none;
  }
  .text-right{
    text-align: right;
  }
  .btn_tabs{
    .el-tabs__header{
      border-bottom: none;
    }
    .el-tabs__item.is-active{
      background: #20a0ff;
      color: #fff;
    }
    .el-tabs__item{
      border-radius: 100px;
      height: 30px;
      line-height: 30px;
      font-size: 12px;
      color: #5E6977;
      background: #CFD6DB;
      margin-right: 10px;
    }
  }
  .table_area{
    table{
      width: 100%;
      border-collapse: collapse;
      thead{
        td{
          font-size: 14px;
          color: #7F8FA4;
        }
      }
      td{
        padding: 10px 5px;
      }
      tbody td{
        font-size: 14px;
        color:  #354052;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// TrustFormLayout.vue?7cd5030e